// @core/stores/activity/ActivityActivityMappingStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { activityApi } from '@core/api';
import type {
  CreateMappingConfigRequest,
  DeleteMappingConfigResponse,
  ListMappingConfigsResponse,
  MappingConfigResponse,
  UpdateMappingConfigRequest,
} from '@core/types/activity';

class ActivityActivityMappingStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Create activity mapping config
   */
  async CreateMappingConfig(data: CreateMappingConfigRequest): Promise<MappingConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.CreateMappingConfig(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Delete activity mapping config
   */
  async DeleteMappingConfig(id: string): Promise<DeleteMappingConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.DeleteMappingConfig(id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List activity mapping configs
   */
  async ListMappingConfigs(params?: { limit?: string | number | boolean; cursor?: string | number | boolean; direction?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListMappingConfigsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.ListMappingConfigs(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update activity mapping config
   */
  async UpdateMappingConfig(id: string, data: UpdateMappingConfigRequest): Promise<MappingConfigResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.UpdateMappingConfig(id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const activityActivityMappingStore = new ActivityActivityMappingStore();
